import { fn, hash } from "@ember/helper";
import FormFieldComboBox from "../combo-box";
import CustomFieldBase from "./base";

export default class CustomFieldDropdown extends CustomFieldBase {
  get noneLabel() {
    return "discourse_circles.form.select_one_option";
  }

  <template>
    <FormFieldComboBox
      ...attributes
      @name={{@field.name}}
      @title={{this.title}}
      @showTitle={{this.shouldDisplayTitle}}
      @description={{this.description}}
      @showDescription={{this.shouldDisplayDescription}}
      @placeholder={{this.placeholder}}
      @showPlaceholder={{this.shouldDisplayPlaceholder}}
      @required={{@field.required}}
      @content={{@field.options}}
      @valueProperty={{null}}
      @nameProperty={{null}}
      @value={{@value}}
      @onChange={{fn (mut @value)}}
      @validation={{@validation}}
      @options={{hash none=this.noneLabel}}
    >
      {{yield}}
    </FormFieldComboBox>
  </template>
}
